

import React from 'react';
import { connect } from 'react-redux';
import RegisterOtpComponent from './RegisterOtp';
import RegisterCredentialsComponent from './RegisterCredentials';
import RegisterFirstStepComponent from './RegisterFirstStep';
import AnimationWrapper from '../../Utils/animationWrapper.js';

class RegisterPageRootComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            currentRegisterPart: "registerFirstStep"
        }
    }

    componentDidMount() {
       
    }

    changeCurrentRegisterPart = (type) => {
        console.log("inside changeRegisterPart >>" + type);
        this.setState({
            currentRegisterPart: type
        });
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.componentContent()}
            </div>
        )
    }

    componentContent() {
        return (
            <AnimationWrapper.switchTransition
                    switchTrigger={this.state.currentRegisterPart}
                    triggerValueForChild0="registerFirstStep"
                    triggerValueForChild1="registerOtp"
                    triggerValueForChild2="registerCredentials"
                    classNames={{ enterActive: 'notransition', exitActive: 'notransition'}}
                    timeout="0"
                >
                    <RegisterFirstStepComponent changeCurrentRegisterPartTo={this.changeCurrentRegisterPart} />
                    <RegisterOtpComponent changeCurrentRegisterPartTo={this.changeCurrentRegisterPart} />
                    <RegisterCredentialsComponent changeCurrentRegisterPartTo={this.changeCurrentRegisterPart} />
                </AnimationWrapper.switchTransition>
        )
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales
    }
}
function mapDispatchToProps(dispatch) {
    return {
    }
}

const RegisterPageRootComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterPageRootComponent)


export default RegisterPageRootComponentContainer;